export default __webpack_public_path__ + "static/media/nc-pattern.27a1695c.png";